import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthShell from "@/platform/components/AuthShell";
import { Button, GoogleButton, TextField, Divider } from "@/platform/components/primitives";
import PasswordField from "@/platform/components/PasswordField";
import { api } from "@/platform/api";
import { postAuthPath } from "@/platform/pendingInvite";
import { useAuth } from "@/platform/AuthContext";
import { startGoogle } from "@/platform/pages/Signup";

export default function Login() {
  const navigate = useNavigate();
  const { applyAuth } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setError("");
    setLoading(true);
    try {
      const payload = await api.post("/api/auth/login", { email: email.trim(), password });
      applyAuth(payload);
      navigate(postAuthPath(payload), { replace: true });
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <AuthShell
      altAction={{ label: "New to Pinlayr?", to: "/signup", cta: "Create one" }}
      footer={<span>Don’t have an account? <Link to="/signup" className="font-semibold text-[#F4F5F8] hover:underline">Create one</Link></span>}
    >
      <div className="animate-in fade-in duration-500">
        <h1 className="text-[26px] font-semibold tracking-tight text-[#F4F5F8]">Welcome back</h1>
        <p className="mt-2 text-[15px] text-[#98A0B0]">Sign in to your Pinlayr workspace.</p>

        <div className="mt-8">
          <GoogleButton onClick={() => { setGoogleLoading(true); startGoogle(); }} loading={googleLoading} label="Sign in with Google" />
        </div>

        <div className="my-5"><Divider /></div>

        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <TextField id="email" label="Email" type="email" placeholder="you@company.com" value={email} onChange={(e) => setEmail(e.target.value)} autoFocus data-testid="login-email" />
          <div>
            <PasswordField value={password} onChange={setPassword} showStrength={false} label="Password" />
            <div className="mt-1.5 text-right">
              <Link to="/forgot" className="text-[12.5px] font-medium text-[#98A0B0] hover:text-[#F4F5F8]">Forgot password?</Link>
            </div>
          </div>
          {error && <p className="text-[12.5px] text-red-500" data-testid="login-error">{error}</p>}
          <Button type="submit" loading={loading} data-testid="login-submit">Sign in</Button>
        </form>
      </div>
    </AuthShell>
  );
}
